import Vue from 'vue'
import Vue2Filters from 'vue2-filters'
import BootstrapVue from 'bootstrap-vue'
import router from '@/router'
import store from '@/store'
import * as filters from '@/filter'
import ScrollManager from '@/lib/ScrollManager'
import App from '@/App'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import {
  calendarDefaults,
  calendarLangFunc
} from './consts/calendar'

// plugin setup
Vue.config.productionTip = false
Vue.use(BootstrapVue)

// consts
window.VueCalendarDefaults = calendarDefaults
window.VueCalendarLang = calendarLangFunc

// register filters
Vue.use(Vue2Filters)
Object.keys(filters).forEach(k => {
  Vue.filter(k, filters[k])
})

// register global components
Vue.component('my-calendar', require('@/components/lib/MyCalendar').default)
Vue.component('pager', require('@/components/lib/Pager').default)
Vue.component('modal', require('@/components/lib/Modal').default)
Vue.component('sort-button', require('@/components/lib/SortButton').default)
Vue.component('joint-list', require('@/components/lib/JointList').default)
Vue.component('joint-master-list', require('@/components/lib/JointMasterList').default)
Vue.component('pole-list', require('@/components/lib/PoleList').default)
Vue.component('pole-master-list', require('@/components/lib/PoleMasterList').default)
Vue.component('extreme-map', require('@/components/lib/ExtremeMap/ExtremeMap').default)

new Vue({
  created: function() {
    window.scrollManager = new ScrollManager()
  },
  router,
  store,
  render: h => h(App)
}).$mount('#app')
